var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('financial-overview'):_c('legacy-dashboard')
}
var staticRenderFns = []

export { render, staticRenderFns }